
import TestimonialCard from "@/components/TestimonialCard";
import { memo } from "react";
import { Info, MessageSquareQuote } from "lucide-react";

const TestimonialsSectionHome = () => {
  return (
    <section className="section-spacing bg-white relative">
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-joerg-50/50 to-transparent"></div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            <MessageSquareQuote className="h-4 w-4 mr-2" />
            Stimmen meiner Kunden
          </span>
          <h2 className="text-center animate-fade-in" style={{ animationDelay: '100ms' }}>
            Was meine Klienten über meine Arbeit sagen
          </h2>
          <p className="text-joerg-600 mt-4 animate-fade-in text-left" style={{ animationDelay: '150ms' }}>
            Authentische Erfahrungsberichte aus dem Finanzcoaching und Executive Coaching
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <TestimonialCard
            content="Jörg hat mir geholfen, mein Verhältnis zu Finanzen grundlegend zu überdenken. Durch sein Coaching habe ich gelernt, informierte Entscheidungen zu treffen, die wirklich zu mir passen."
            author="Julia S."
            role="Marketing Direktorin"
            delay={100}
          />
          <TestimonialCard
            content="Die Zusammenarbeit mit Jörg hat unserer Führungsebene völlig neue Perspektiven eröffnet. Seine Verbindung von Finanzexpertise und empathischem Coaching ist einzigartig."
            author="Michael K."
            role="Geschäftsführer"
            delay={300}
          />
          <TestimonialCard
            content="Mit Jörgs Hilfe konnte ich endlich ein gesundes Verhältnis zu meinen Finanzen entwickeln. Seine Methode verbindet Fachwissen mit emotionaler Intelligenz auf beeindruckende Weise."
            author="Stefanie R."
            role="Projektleiterin"
            delay={500}
          />
        </div>
        
        <div className="mt-8 text-sm text-joerg-500 flex items-center">
          <Info className="h-4 w-4 mr-2 text-joerg-400 flex-shrink-0" />
          <span>Aus Datenschutzgründen wurden Namen pseudonymisiert. Die beruflichen Angaben entsprechen den tatsächlichen Tätigkeitsfeldern. Alle Testimonials basieren auf echtem Feedback.</span>
        </div>
      </div>
    </section>
  );
};

export default memo(TestimonialsSectionHome);
